var map = {
	"./call-control.svg": 88359,
	"./end.svg": 61410,
	"./keypad.svg": 29015,
	"./microphone-off.svg": 38607,
	"./microphone-on.svg": 76499,
	"./park.svg": 52975,
	"./pause-off.svg": 72275,
	"./pause-on.svg": 31767,
	"./pending-transfer.svg": 38004,
	"./record-off.svg": 99844,
	"./record-on.svg": 11886,
	"./segment.svg": 12918,
	"./transfer.svg": 66190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41295;